
export default {
  name: 'Social',
}
